import React from 'react';
import PropTypes from 'prop-types';
import BroadageWidget from '../../components/BroadageWidget';
import Icon from '../../components/Icon';
import { useHistory } from 'react-router-dom';
import BreadCrumb from './BreadCrumb';
import { useSelector } from 'react-redux';
import ToogleSeoText from '../../components/ToogleSeoText';
import { withMixpanel } from '../../../utils/mixpanel';
import { isWebviewMode } from 'Utils/webviewMode';
import { Helmet } from 'react-helmet';

export const LeagueLanding = ({ data, mixpanel, isSideNavOpen, setIsSideNavOpen }) => {
  const history = useHistory();
  const userAgent = useSelector(state => state.userAgent);
  const isMobile = userAgent?.device?.type === 'mobile';
  const isWebView = isWebviewMode(history?.location?.search);

  return (<>
      <Helmet>
        <meta property="og:title" content={ data?.meta?.title } />
        <meta property="og:description" content={ data?.meta?.description } />
      </Helmet>
      <div className="league-content">
        <div className={ `league-content__header-container ${isWebView ? 'webview' : 'desktopview'}` }>
          { !isWebView && <div className="league-content__back" onClick={ () => {
            const search = history?.location?.search || '';
            history.push(`/${ search }`);
          } }>
            <Icon iconName="svgBackIcon"/>
          </div> }
          <div className="league-content__title">
            <Icon iconName="svgBLogo"/>
            <span className='league-content__title__span'>{ data?.name }</span>
            { isMobile && (
              <>
                { isSideNavOpen
                  ? <Icon onClick={ () => setIsSideNavOpen(!isSideNavOpen) } iconName="svgHamburgerClose"/>
                  : <Icon onClick={ () => setIsSideNavOpen(!isSideNavOpen) } iconName="svgHamburgerMenu"/>
                }
              </>
            ) }
          </div>
        </div>

        { data?.banners?.top && data.banners.top.length > 0 && (
          <div className="league-content__banner-container">
            { data.banners.top[0].deeplink ? (
              <a
                href={ data.banners.top[0].deeplink }
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ data.banners.top[0].image } alt="Banner"/>
              </a>
            ) : (
              <img src={ data.banners.top[0].image } alt="Banner"/>
            ) }
          </div>
        ) }
        { isMobile && !isWebView && <BreadCrumb data={ data }/> }

        <div className="league-content__widget-container">
          <div className="livescore-container">
            <BroadageWidget
              type="liveScore"
            />
            <div className="match-card__statistics-info">
              <Icon iconName="svgInfoGrey"/>
              <div>
                İstatistik sağlayıcı firma tarafından sunulan verilerde oluşabilecek kusurlardan <span
                  className="match-card__statistics-info-highlight">Bilyoner sorumlu değildir.</span>
              </div>
            </div>

            { data?.banners?.bottom && data.banners.bottom.length >= 3 && (
              <div className="league-content__bottom-banners-container">
                <div className="league-content__bottom-banners">
                  { data.banners.bottom?.map((banner, index) => (
                    <div key={ index } className="banner">
                      { banner.deeplink && (
                        <a
                          href={ banner.deeplink }
                          rel="noopener noreferrer"
                        >
                          <img onClick={ () =>
                            mixpanel?.track('Click League Center Banner', { 'Banner Name': `Banner ${index + 1}` })
                          }
                          src={ banner.image } alt={ banner.alt || `Banner ${index + 1}` }/>
                        </a>
                      ) }
                    </div>
                  )) }
                </div>
              </div>
            ) }
            <ToogleSeoText
              text={ data?.meta?.description }
              title={ data?.meta?.title }
              extraClass="events-container__seo__height-fix"
            />
          </div>
        </div>
      </div>

    </>
  );
};

LeagueLanding.propTypes = {
  data: PropTypes.object.isRequired,
  mixpanel: PropTypes.object,
  isSideNavOpen: PropTypes.bool,
  setIsSideNavOpen: PropTypes.func
};

export default withMixpanel(LeagueLanding);
